<!--
 * @Descripttion: 新增模板
 * @Date: 2025-07-30 14:08:51
-->
<template>
  <BaseDialog class="bi-tmpl-add-dialog" title="新增模板" width="500px">
    <BaseTextContent>
      <BaseForm ref="baseFormRef" label-position="top" :model="formData">
        <BaseFormItem
          prop="sceneType"
          label="关联内容"
          :rules="[
            {
              required: true,
              message: '请选择关联内容',
              trigger: 'change'
            }
          ]"
        >
          <BaseSelect
            :options="
              Object.values(SCENE_MAPPING).sort((a, b) => a.sort - b.sort)
            "
            v-model="formData.sceneType"
          ></BaseSelect>
        </BaseFormItem>
        <BaseFormItem prop="templateId" label="从已有模板快速创建">
          <BaseSelect
            clearable
            filterUseRemote
            value-key="id"
            label-key="templateName"
            :remoteMethod="remoteMethod"
            v-model="formData.templateId"
          ></BaseSelect>
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>

    <template #footer>
      <BaseButton type="default" @click="onCancel">取消</BaseButton>
      <BaseButton :click="onConfirm">确认</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  BaseDialog,
  BaseTextContent,
  BaseForm,
  BaseFormRef,
  BaseFormItem,
  BaseButton,
  BaseSelect,
  XrkMessage
} from 'xrk-components';
import { SCENE_MAPPING } from '../constants/index';
import { list } from '../data-source/apis';

const props = withDefaults(
  defineProps<{
    remove?: () => void;
  }>(),
  {}
);
const router = useRouter();

const formData = ref({
  sceneType: null,
  templateId: null
});
const baseFormRef = ref<BaseFormRef>(null);

const remoteMethod = async (templateName: string) => {
  if (!formData.value.sceneType) {
    return XrkMessage.error('请先选择关联内容');
  }
  return list({
    sceneType: formData.value.sceneType,
    templateName,
    pageNum: 1,
    pageSize: 50
  });
};

const onCancel = () => {
  props?.remove?.();
};
const onConfirm = async () => {
  await baseFormRef.value.validate();
  props?.remove?.();
  router.push({
    name: 'bi-tmpl-detail',
    query: {
      id: formData.value.templateId,
      sceneType: formData.value.templateId
        ? undefined
        : formData.value.sceneType
    }
  });
};
</script>

<style lang="scss" scoped>
// .bi-tmpl-add-dialog {}
</style>
